export default "__VITE_ASSET__CYpanOh3__"